import React from 'react';
import { HelpCircle, X } from 'lucide-react';

interface PortalGuruModalKonfirmasiPulangProps {
    onConfirm: () => void;
    onCancel: () => void;
}

export const PortalGuruModalKonfirmasiPulang: React.FC<PortalGuruModalKonfirmasiPulangProps> = ({ onConfirm, onCancel }) => {
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center px-4">
            <div className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm transition-opacity" onClick={onCancel}></div>
            <div className="relative w-full max-w-sm bg-white rounded-3xl p-6 shadow-2xl ring-1 ring-white/10 transform transition-all animate-in slide-in-from-bottom-10 fade-in duration-300 text-center">
                <div className="mx-auto w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center mb-6 ring-8 ring-blue-50">
                    <HelpCircle size={40} className="text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-[#111813] tracking-tight mb-2">Konfirmasi Pulang</h3>
                <p className="text-sm text-gray-600 mb-8 leading-relaxed">
                    Apakah antum sudah benar selesai bekerja hari ini?
                </p>

                <div className="flex gap-3">
                    <button
                        onClick={onCancel}
                        className="flex-1 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold rounded-xl transition-colors"
                    >
                        Batal
                    </button>
                    <button
                        onClick={onConfirm}
                        className="flex-1 py-3 bg-[#40513B] hover:bg-[#344230] text-white font-bold rounded-xl shadow-lg shadow-[#40513B]/20 transition-all active:scale-[0.98]"
                    >
                        Ya, Selesai
                    </button>
                </div>
            </div>
        </div>
    );
};
